angular.module('components.media.AudioController', [
  'global',
  'components.media.AudioService'
])

/**
 * The AudioController manages scope logic and user
 * interaction.
 *
 * @class AudioController
 * @constructor
 * @module components.media.AudioController
 */
.controller('AudioController', [
  '$scope',
  '$sce',
  '$window',
  function ($scope, $sce, $window) {
    'use strict';

    $scope.formattedModel = {};

    function sppMessage(event) {
      var data = JSON.parse(event.data);
      console.log(data);

      if (data.topicData && data.topicData.interactionSpecifier === 'mediaReady') {
        $window
          .frames[0]
          .postMessage('{"type":"command","method":"play","playerId":"SmartPearsonPlayer"}', '*');
      }
    }

    /**
     * Method executes the initialization process.
     *
     * @private
     */
    function initialize() {
      $scope.formattedModel = $scope.model;
      $scope.formattedModel.uri = $sce.trustAsResourceUrl($scope.formattedModel.uri);

      console.log($scope.formattedModel);

      if ($scope.formattedModel.autoplay) {
        $window.addEventListener('message', sppMessage, false);
      }
    }

    initialize();
  }
]);
